import AuthenticatedRoute from 'fabscale-app/routes/base/-base-authenticated-route';
import MaintenanceTasksOpenController from './controller';

export default class TasksOpenRoute extends AuthenticatedRoute {
  resetController(controller: MaintenanceTasksOpenController) {
    controller.filters = null;
  }
}
